import Alpine from 'alpinejs'
import threeQLoader from './three-q-loader'

Alpine.data('videoPlayer', (
    videoId: string,
    videoKey: string,
    videoKeyTimestamp: number,
    videoOffset: number,
    videoEnd: number,
    subTitleLanguageCode: string|null,
    playbackUID: string,
    productId: string,
    videoHasSubtitles: boolean
) => ({

    player: null,
    state: 'uninitialized',
    playbackTracked: 0,
    videoImpressionTracked: false,

    init() {
        threeQLoader().then(js3q => this.onLoad(js3q))
    },

    onLoad(js3q) {
        this.player = new js3q({
            dataid: videoId,
            key: videoKey,
            timestamp: videoKeyTimestamp,
            container: 'product-video-player',
            autoplay: false,
            allowmutedautoplay: true,
            tintColor : '#B4146E',
            defaultCC : subTitleLanguageCode || ''
        })
        if(subTitleLanguageCode) {
            this.player.mute()
        }
        this.player.on('media.timeChange', (data) => this.onMediaTimeChange(data))
    },

    onDestroy() {
        if(!this.player) {
            return
        }
        this.player.destroy()
    },

    onMediaTimeChange(videoPositionSeconds) {
        this.seekBounds(videoPositionSeconds)
        this.trackPlayback(videoPositionSeconds)
    },

    trackPlayback(videoPositionSeconds) {

        if(!this.videoImpressionTracked) {
            window.algolia.view_video(productId)
            this.videoImpressionTracked = true
        }

        const secondsPlayed = Math.max(0, videoPositionSeconds-videoOffset)
        if(secondsPlayed < this.playbackTracked+5) {
            return
        }

        this.playbackTracked = secondsPlayed - secondsPlayed%5
        window.gtag('event', 'product_video_progress', {
            'product_id' : productId,
            'playback_uid' : playbackUID,
            'seconds_played' : this.playbackTracked,
            'has_subtitles' : videoHasSubtitles
        })
    },

    seekBounds(videoPositionSeconds) {
        if(videoOffset <= 0) {
            return
        }
        if(videoPositionSeconds <= 0) {
            return
        }

        // seek to begin

        if(this.state === 'seekBegin') {
            this.state = 'seekingBegin'
            this.player.seek(videoOffset)
            return
        }
        if(this.state === 'seekingBegin' && videoPositionSeconds >= videoOffset) {
            this.state = 'ready'
            return
        }
        if(videoPositionSeconds < videoOffset) {
            this.state = 'seekBegin'
            this.player.play()
            return
        }

        // seek to end

        if(this.state === 'seekRewind') {
            this.state = 'seekRewinding'
            this.player.seek(videoOffset)
            return
        }
        if(this.state === 'seekRewinding' && Math.abs(videoPositionSeconds-videoOffset) < 3) {
            this.state = 'ready'
            this.player.pause()
            return
        }
        if(videoPositionSeconds > videoEnd) {
            this.state = 'seekRewind'
            return
        }
    },

    start() {
        if(!this.player) {
            return
        }
        if(videoOffset > 0) {
            this.state = 'seekBegin'
        } else {
            this.state = 'ready'
        }
        this.player.play()
    },

    stop() {
        if(!this.player) {
            return
        }
        this.player.pause()
    }

}))